export type StreamOrFile = 'STREAM' | 'FILE';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isStreamOrFile = (data: any): data is StreamOrFile => data === 'STREAM' || data === 'FILE';
